import React from "react";
import { ChevronIcon } from "./ChevronIcon";

export const ChevronUpIcon = (props: React.ComponentProps<typeof ChevronIcon>) => <ChevronIcon {...props} direction="up" />;
